export class WtUpdateQuoteResponse {
  quoteNumber?: string;
  quoteExpiryDate: string;
  events: event[];
}

export class event {
  eventName: string;
  eventDays: eventDay[];
}

export class eventDay {
  startDateTime: string;
  endDateTime: string;
  coverages: coverage[]
}

export class coverage {
  peril: string;
  costs: cost[];
}

export class cost {
  threshold: string;
  limit: string;
  cost: string;
  eventPeriod: string;
  eligible: boolean;
}
